import { Form } from "react-bootstrap"

import Checkbox from "../../Checkbox"

interface SelectObservedProps {
  checked?: boolean
  disabled?: boolean
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

function SelectObserved(props: SelectObservedProps) {
  const { checked, disabled, onChange } = props

  return (
    <Form.Group>
      <Checkbox
        label="OBSERVED"
        id="observed-checkbox"
        className="font-weight-bold ml-2"
        name="observedCollection"
        checked={checked}
        disabled={disabled}
        onChange={onChange}
      />
    </Form.Group>
  )
}

SelectObserved.defaultProps = {
  checked: false,
  disabled: false,
}

export default SelectObserved
